import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useMutation, useQuery, QueryClient } from "react-query";
import { useParams, useHistory } from "react-router-dom";
import { Container, Stack, Typography, Card } from '@mui/material';
import { isEmpty } from "lodash";

// components
import Page from 'components/Page';
// service
import { getUser, updateUser } from "services/user.service";
import { getCorporates } from "services/userCorporate.service";
import { getApps } from "services/userApp.service";
import { getLicenses, assignLicense } from "services/userLicense.service";
import { fToInputDate } from "utils/formatTime";

import UserForm from "./UserForm";

const EditUserForm = () => {
  const history = useHistory();
  const queryClient = new QueryClient();
  const currentUser = useSelector((state) => state.userData?.currentUser);
  const selectedOrg = useSelector((state) => state.userData?.orgId);

  const { id } = useParams();
  const { isSuccess: isSuccessUser, data: resUser, refetch } = useQuery(["user-edit", { userId: id }], getUser, {refetchOnMount: false});
  const { isSuccess: isSuccessCorp, data: resCorp } = useQuery(["corporates", { orgIds: currentUser?.organizations ?? [] }], getCorporates);
  const { isSuccess: isSuccessApp, data: resApp } = useQuery(["apps"], getApps); 
  const { isSuccess: isSuccessLicense, data: resLicense } = useQuery(["licenses", 
  { 
    ownerId: resUser?.organizations, 
    userAccessControl: resUser?.uId 
  }], 
  getLicenses, 
  {
    enabled: isSuccessUser && isSuccessApp
  });
  const { isSuccess: isSuccessLicenseAdmin, data: resLicenseAdmin } = useQuery(["licenses", 
  { 
    ownerId: currentUser?.organizations, 
    userAccessControl: currentUser?.uId 
  }], 
  getLicenses, 
  {
    enabled: isSuccessUser && isSuccessLicense
  });
  
  const [finishLoadApp, setFinishLoadApp] = useState(false);
  const [finishLoadUser, setFinishLoadUser] = useState(false);
  const [finishLoad, setFinishLoad] = useState(false);

  const [userState, setUserState] = useState({});
  const [corps, setCorps] = useState([]);
  const [apps, setApps] = useState([]);
  const [availableApps, setAvailableApps] = useState([]);

  useEffect(() => {
    if (isSuccessUser) {
      setUserState({
        ...resUser,
        dateOfBirth: resUser.dateOfBirth ? fToInputDate(resUser.dateOfBirth) : "",
        gender: resUser.gender === "" ? "man" : resUser.gender,
        country: resUser.country === "" ? "SG" : resUser.country
      });
      setFinishLoadUser(true);
    }
  }, [isSuccessUser, resUser]);

  useEffect(() => {
    if (isSuccessCorp) {
      setCorps(resCorp.map(item => (
        {
          value: item.uId,
          label: item.corpName
        }
      )));
    }
  }, [isSuccessCorp, resCorp]);

  useEffect(() => {
    if (isSuccessApp) {
      setApps(resApp.map(item => (
        {
          value: item.code,
          label: item.name
        }
      )));
      setFinishLoadApp(true);
    }
  }, [isSuccessApp, resApp]);

  useEffect(() => {
    if (!isEmpty(userState)) {
      if (resLicense) {
        const orgAccessControls = [];
        userState.organizations?.map((x, index) => {
          orgAccessControls[index] = [];

          console.log(resLicense, "LICEN")
          const licenses = resLicense.filter(l => l.ownerId === x);
          orgAccessControls[index].push("Eprofile");
  
          licenses.map(l => {
            orgAccessControls[index].push(l.appAccessControl);
          })
        });

        setUserState({
          ...userState,
          orgAccessControls
        });
      }
    }
  }, [isSuccessLicense, resLicense, finishLoadUser, finishLoadApp]);

  useEffect(() => {
    if (!isEmpty(userState)) {
      if (resLicenseAdmin) {
        const orgApps = {};
  
        currentUser?.organizations?.map((x) => {
          orgApps[x] = [];
  
          const licenses = resLicenseAdmin.filter(l => l.ownerId === x);
          const eprofileApp = apps.find(a => a.value.toLowerCase() === "eprofile");
          if (eprofileApp) {
            orgApps[x].push(eprofileApp);
          }
  
          licenses.map(l => {
            const licenseApp = apps.find(a => a.value === l.appAccessControl);
            if (licenseApp) {
              orgApps[x].push(licenseApp);
            }
          })
        });

        setAvailableApps(orgApps);
        setFinishLoad(true);
      }
    }
  }, [isSuccessLicenseAdmin, resLicenseAdmin, finishLoadUser, finishLoadApp]);

  const submitUser = useMutation(values => {
    return updateUser({values, userId: id});
  });

  const submitLicense = useMutation(licenseValues => {
    return assignLicense({
      values: licenseValues
    })
  })

  const onSubmitUser = (values) => {
    submitUser.mutate(values, {
      onSuccess: (res) => {
        if (res) {
          const licenseValues = {
            userId: res.uId,
            adminOrganizations: currentUser?.organizations,
            organizations: JSON.parse(values.get("organizations")),
            orgAccessControls: JSON.parse(values.get("orgAccessControls"))
          }

          submitLicense.mutate(licenseValues, {
            onSuccess: async(res) => {
              // queryClient.setQueriesData(["user-edit", { userId: id }], res)
              await refetch();
              history.goBack();
            }
          })
        }
      }
    });
  }

  return (
    <Page title="User">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Edit User
          </Typography>
        </Stack>

        <Card>
          {
            (finishLoad === true && !isEmpty(userState)) && (
              <UserForm 
                initialValues={{
                  ...userState,
                  password: "",
                  confirmPassword: "",
                }}
                corps={corps}
                apps={availableApps}
                currentUser={currentUser}
                selectedOrg={selectedOrg}
                isEdit={true}
                onSubmit={onSubmitUser}
              />
            )
          }
        </Card>
      </Container>
    </Page>
  );
}

export default EditUserForm;